import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { Activity } from '../../../../api/activity/activity.model';
import { first, map, of, switchMap } from 'rxjs';
import { ActivityService } from '../../../../api/activity/activity.service';
import { getTargetFilter } from '../../../../util/target.util';

export function duplicateActivityValidator(
  apiSvc: ActivityService,
  resource: Activity,
): AsyncValidatorFn {
  return (control: AbstractControl) => {
    return of(control.value).pipe(
      switchMap((value) => {
        if (!value || !value.id) {
          return of(null); // no validation error
        }
        return apiSvc
          .list({
            filters: {
              ...getTargetFilter(resource, 'id'),
              'staff.id': value.id,
            },
          })
          .pipe(
            map((result) => {
              return result?.length > 0 ? { duplicate: true } : null;
            }),
          );
      }),
      first(), // complete the observable
    );
  };
}
